module.exports = __webpack_public_path__ + "granuli_pp-img@2x.jpg?a2c63d3ae283fb3296dec62c7883a3b5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/granuli_pp-img@2x.jpg
// module id = 196
// module chunks = 0